import { Component, OnInit, Input, TemplateRef, Output, EventEmitter } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { isString, cloneDeep, forEach, find, indexOf } from 'lodash';
import { PlatfromUserAccssManagementService } from '../../services/platform-user-access-management.service';
import { CreateUserCommand } from '../../models/platform-user-access-management.model';

@Component({
    selector: 'app-platform-user-access-management-header',
    templateUrl: './platform-user-access-management-header.component.html',
    styleUrls: ['./platform-user-access-management-header.component.scss'],
    standalone: false
})
export class AppPlatformTeamManagementHeaderComponent implements OnInit {
    @Input() headerTemplate: TemplateRef<any>;
    @Input() uamConfig: any;
    @Output() onPayloadUpdate: EventEmitter<any> = new EventEmitter<any>();
    loading: boolean = false;
    headerlangKey: any;
    createButtonLangKey: any;
    filterByLangKey: any;
    tableModel: any;
    searchKey: any;
    enableSearchUser: boolean = false;
    enableFilterByRole: boolean = false;
    enableToCreateUser: boolean = false;
    userRolesFilter: any[] = [];
    seletedFilterRole: any;
    seletedSearchBy: any;
    searchByList: any[] = [];
    defaultSearchBy: any = [
        {
            Icon: 'people',
            Label: 'DisplayName',
            PlaceHolder: 'search displayname',
            PropertyName: 'DisplayName'
        }
    ];
    useCustomHeaderTemplate: boolean = false;
    requestData: any;
    uamViews: any;
    constructor(
        public snackBar: MatSnackBar,
        public platfromUserAccssManagementService: PlatfromUserAccssManagementService
    ) {}

    ngOnInit(): void {
        this.useCustomHeaderTemplate = this.uamConfig && this.uamConfig.UseCustomHeaderTemplate;
        this.headerlangKey = (this.uamConfig && this.uamConfig.HeaderTitleLangKey) || 'USER_LIST_TITLE';
        this.createButtonLangKey = (this.uamConfig && this.uamConfig.CreateButtonTextLangKey) || 'CREATE_BUTTTON_TEXT';
        this.filterByLangKey = (this.uamConfig && this.uamConfig.FilterByLangKey) || 'FILTER_BY';
        this.uamViews = this.platfromUserAccssManagementService.getViews();
        this.enableToCreateUser = this.uamConfig && this.uamConfig.EnableCreateNewUser;
        this.enableSearchUser = this.uamConfig && this.uamConfig.EnableSearch;
        this.requestData = {
            PageNumber:
                (this.uamConfig && this.uamConfig.RequestFilter && this.uamConfig.RequestFilter.PageNumber) || 0,
            PageLimit: (this.uamConfig && this.uamConfig.RequestFilter && this.uamConfig.RequestFilter.PageLimit) || 10,
            OrderBy:
                (this.uamConfig && this.uamConfig.RequestFilter && this.uamConfig.RequestFilter.OrderBy) ||
                'CreateDate',
            SortOrder:
                (this.uamConfig && this.uamConfig.RequestFilter && this.uamConfig.RequestFilter.SortOrder) ||
                'Descending',
            SearchFilters:
                (this.uamConfig && this.uamConfig.RequestFilter && this.uamConfig.RequestFilter.SearchFilters) || {}
        };
        this.requestData.PropertyFromPerson = (this.uamConfig && this.uamConfig.PropertyFromPerson) || [];

        if (this.enableSearchUser) {
            this.searchByList = (this.uamConfig && this.uamConfig.SeachByList) || this.defaultSearchBy;
            this.seletedSearchBy = this.searchByList && this.searchByList[0];
        }

        this.enableFilterByRole = this.uamConfig && this.uamConfig.EnableFilterByRole;
        if (this.enableFilterByRole) {
            this.getFilterRoles();
        }
    }

    getTableDataOnPayloadUpdate() {
        let payload = {
            requestData: this.requestData,
            searchKey: this.searchKey,
            seletedSearchBy: this.seletedSearchBy && this.seletedSearchBy.PropertyName
        };
        this.platfromUserAccssManagementService.getTableData(payload);
        // this.onPayloadUpdate.emit(payload);
    }

    getTableDataOnCustomPayload(customPayload) {
        if (customPayload) {
            let payload = {
                requestData: this.requestData,
                searchKey: this.searchKey,
                payload: customPayload
            };
            this.platfromUserAccssManagementService.getCustomUserList(payload);
        }
    }

    /* Search */
    setSelectSearchBy(searchBy) {
        this.resetSearchFilterOfRequestData();
        this.seletedSearchBy = searchBy;
    }
    resetSearchFilterOfRequestData() {
        delete this.requestData.SearchFilters[this.seletedSearchBy && this.seletedSearchBy.PropertyName];
        if (
            !this.seletedFilterRole &&
            !(this.uamConfig.RequestFilter.SearchFilters && this.uamConfig.RequestFilter.SearchFilters.Roles)
        )
            delete this.requestData.SearchFilters['Roles'];
        Object.assign(
            this.requestData.SearchFilters,
            (this.uamConfig && this.uamConfig.RequestFilter && this.uamConfig.RequestFilter.SearchFilters) || {}
        );
    }
    getResultForSearchKey(ev) {
        if (this.searchKey && isString(this.searchKey)) {
            this.requestData.PageNumber = 0;
            this.resetSearchFilterOfRequestData();
            this.getTableDataOnPayloadUpdate();
            // this.platfromUserAccssManagementService.getUserList(this.searchKey, this.seletedSearchBy && this.seletedSearchBy.PropertyName, cloneDeep(this.requestData)).subscribe(response => {
            //    // this.setUserListOnDataTable(response);
            // });
        } else if (this.searchKey == '') {
            this.clearSearchKey();
        }
    }
    clearSearchKey() {
        if (!this.searchKey) {
            this.searchKey = '';
            this.resetSearchFilterOfRequestData();
            this.getTableDataOnPayloadUpdate();
            // this.getTableData(this.tableModel);
        }
    }
    searchFieldCloseIconClick() {
        this.searchKey = '';
        this.resetSearchFilterOfRequestData();
        this.getTableDataOnPayloadUpdate();
        //this.getTableData(this.tableModel);
    }
    /* Search End*/

    /* Filter */
    getFilterRoles() {
        this.platfromUserAccssManagementService
            .getUsersRoles(this.uamConfig && this.uamConfig.RolesFilter)
            .subscribe(response => {
                this.userRolesFilter = this.getRolesWithValues(response && response.Roles);
                this.setDefaultRole();
            });
    }

    setDefaultRole() {
        if (this.enableFilterByRole && this.uamConfig && this.uamConfig.DefaultSelectedRole) {
            this.seletedFilterRole = find(this.userRolesFilter, this.uamConfig && this.uamConfig.DefaultSelectedRole);
        }
    }
    getRolesWithValues(roles) {
        let roleList = [];
        forEach(roles, role => {
            forEach(this.uamConfig && this.uamConfig.RolesFilter, filter => {
                if (this.isAvailable(filter, role)) {
                    roleList.push({
                        Value: (filter && filter.ReplacedValue) || (role && role.RoleName),
                        Role: role && role.RoleName
                    });
                }
            });
        });
        if (this.uamConfig && this.uamConfig.ExtraRolesOfFilter && this.uamConfig.ExtraRolesOfFilter.length) {
            forEach(this.uamConfig.ExtraRolesOfFilter, role => {
                roleList.unshift(role);
            });
        }
        return roleList;
    }

    isAvailable(filter, role) {
        return indexOf(role && role.Tags, filter.Tag) > -1 ? true : false;
    }

    onSelectionChange(role) {
        this.seletedFilterRole = role && role.value;
        if (this.requestData.SearchFilters && this.seletedFilterRole) {
            this.resetSearchFilterOfRequestData();
            this.requestData.SearchFilters['Roles'] =
                this.seletedFilterRole && this.seletedFilterRole.Role ? [this.seletedFilterRole.Role] : undefined;
        }
        this.getTableDataOnPayloadUpdate();
        // this.getTableData(this.tableModel);
    }
    /* Filter End */
    /* Create user */

    createUser() {
        if (this.uamConfig && this.uamConfig.CustomCreateUser) {
            let userModel = new CreateUserCommand();
            this.platfromUserAccssManagementService.OnCreateUser(userModel);
            // this.OnClickCreateUser.emit(userModel);
        } else {
            this.uamViews = this.platfromUserAccssManagementService.getViews();
            this.platfromUserAccssManagementService.updateRoute(this.uamViews.createUser, null);
            // let createUserId = this.ecapCorGuidGeneratorService.getNewGuid();
            //    let componentName = this.uamConfig && this.uamConfig.RefCreateNewUserComponent ? this.getUrlComponent(this.uamConfig && this.uamConfig.RefCreateNewUserComponent) : 'DEFAULT';
            // this.router.navigate([location.pathname, 'new'],{
            //     queryParams: {
            //         root: location.pathname
            //     }
            // });
        }
    }
    ngOnDestroy(): void {}
}
